const LIVE_PREFIX = 'https://datadesk-prod-origin.californiatimes.com';
const TEST_PREFIX = 'https://elections-2022-backend-dev.s3.amazonaws.com';

export const RESULTS_URL = `${
  process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
}/projects/elections-data/2022-04-05/latest.json`;

export const STATE_URL = `${
  process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
}/projects/elections-data/2022-06-07/latest.json`;

export const COUNTY_URL = `${
  process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
}/projects/elections-data/2022-06-07/los-angeles.json`;

export const SF_URL = `${
  process.env.NODE_ENV === 'production' ? LIVE_PREFIX : TEST_PREFIX
}/projects/elections-data/2022-06-07/local.json`;

export const GEOGRAPHY_URL =
  'https://datadesk-prod-origin.californiatimes.com/projects/elections-data/2020-11-03/geographies/states/ca.json';

///   for LOCAL
// export const STATE_URL =
//   'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-06-07/latest.json';

// export const COUNTY_URL =
//   'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-06-07/los-angeles.json';

// export const SF_URL =
//   'https://elections-2022-backend-dev.s3.amazonaws.com/projects/elections-data/2022-06-07/local.json';
